export { default as FavoritesListModel } from './model'
